module.exports = __webpack_public_path__ + "img/4.ad73067b.png";